import { defineMessages } from 'react-intl';

export default defineMessages({
  cancel: {
    id: 'sku.availability-modal.cancel',
    defaultMessage: 'Cancel',
  },
  continue: {
    id: 'sku.availability-modal.continue',
    defaultMessage: 'Continue',
  },
  unavailableTodayDescription: {
    id: 'sku.availability-modal.unavailable-today-description',
    defaultMessage:
      'If you confirm, this order will be canceled, the customer will be notified, and you will not receive a payout for this order.',
  },
});
